const r = () => ({
  makeYoutubeJson: (t, e) => ({
    author: t.author_name,
    authorUrl: t.author_url,
    image: t.thumbnail_url,
    title: t.title,
    url: e
  })
});
export {
  r as default
};
//# sourceMappingURL=useMakeYoutubeJson.js.map
